import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ShuffleTextSpan = styled.div`
  margin: 40px 0;
`;

interface ShuffleTextProps {
  text: string[];
}

const ShuffleText: React.FC<ShuffleTextProps> = ({
  text,
}: ShuffleTextProps) => {
  const [textId, setTextId] = useState<number>(0);

  useEffect(() => {
    const textIdsLength = text.length - 1;
    const timeout = setInterval(() => {
      setTextId((currentTextId) => {
        const newTextId = currentTextId + 1;
        if (currentTextId + 1 === textIdsLength) {
          return 0;
        }
        return newTextId;
      });
    }, 1500);

    return () => {
      clearInterval(timeout);
    };
  }, [textId, text.length]);
  return (
    <ShuffleTextSpan>
      <span>{text[textId]}...</span>
    </ShuffleTextSpan>
  );
};

export default ShuffleText;
